import { gql } from 'apollo-boost'

const COMPLETED_DOCUMENT_MENU_SCRAPING_JOBS_FOR_MENU = gql`
  query completedDocumentMenuScrapingJobsForMenu($menuId: ID!) {
    completedDocumentMenuScrapingJobsForMenu(menuId: $menuId) {
      id
      completedDate
      scrapingStatus
    }
  }
`

export default COMPLETED_DOCUMENT_MENU_SCRAPING_JOBS_FOR_MENU
